export const prodApiUrl = "https://cnx-soofie-api.azurewebsites.net/api";
export const prodTokenUrl = "https://enterprise.apergy.com/Account/Token";
export const preProdApiUrl = "https://auraprod-aurapreprodtest.azurewebsites.net/webapi/api";
export const preProdTokenUrl = "https://auraprod-aurapreprodtest.azurewebsites.net/Account/Token";
export const deventerpriseUrl = "https://enterprise.apergy.com/";
export const newAPIUrl =  process.env.REACT_APP_API_ENDPOINT + "/Auth/authenticate";
export const apiUrls = {
    env: prodApiUrl, 
    token: newAPIUrl, 
};
